// extracted by mini-css-extract-plugin
export default {"figure":"Patterns_figure__bqYH-","caption":"Patterns_caption__1PIvv","grid":"Patterns_grid__nfQdB","multiple":"Patterns_multiple__LRumJ"};